export default "__VITE_ASSET__cLLFq7OX38PQjR0WE41fig__";